// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");

// Styles
require("./organisations.scss");

// JavaScript
var $ = jQuery = require("jquery"),
    $mosaic = $('.sec-organisations__mosaic', $('.sec-organisations').first());

if ($mosaic.length > 0) {

    // Retreive and update block position
    var blockPosition = 0;
    var windowHeight = 0;
    function updateViewport() {
        blockPosition = $mosaic.offset().top;
        windowHeight = $(window).height();
    }
    $(window).on('resize.anim-organisation', function () { requestAnimationFrame(updateViewport); });
    updateViewport();

    // Watch if we should trigger animation
    function checkAnim() {
        if (($(window).scrollTop() + windowHeight) > blockPosition) {
            $mosaic.addClass('sec-organisations__mosaic--animate');
            $(window).off('resize.anim-organisation');
            $(window).off('scroll.anim-organisation');
        }
    };
    $(window).on('scroll.anim-organisation', function () { requestAnimationFrame(checkAnim); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/organisations/index.js
 ** module id = 136
 ** module chunks = 0 1
 **/